import LocationChooserLegend from "./LocationChooserLegend";

export default LocationChooserLegend;
